import React from 'react';

interface BadgeProps {
  variant?: 'default' | 'success' | 'warning' | 'danger' | 'info';
  children: React.ReactNode;
  className?: string;
}

export const Badge: React.FC<BadgeProps> = ({ variant = 'default', children, className = '' }) => {
  const baseClasses =
    'inline-flex items-center rounded-full border px-2.5 py-1 text-xs font-medium whitespace-nowrap';

  const variantClasses = {
    default: 'border-gray-200 bg-gray-100 text-gray-700',
    success: 'border-green-200 bg-green-100 text-green-700',
    warning: 'border-yellow-200 bg-yellow-100 text-yellow-800',
    danger: 'border-red-200 bg-red-100 text-red-700',
    info: 'border-blue-200 bg-blue-100 text-blue-700',
  };

  return (
    <span className={`${baseClasses} ${variantClasses[variant]} ${className}`}>{children}</span>
  );
};
